package top.wcpe.allincore.ui.runtime.reactive

import kotlin.jvm.JvmStatic

/**
 * 反应式系统调试门面：把包内的 [ReactiveContext] 追踪状态暴露给同模块其它包
 * （如 `ui.runtime.ir.call` 的 debug 内建实现）使用，而不提升内部成员可见性。
 *
 * 仅供调试 / 内省用途，不属于对外稳定 API。
 */
object ReactiveDebug {

    /** 当前栈顶 Effect 的重组计数（构造首跑为 1，每次重跑 +1）；不在 Effect 上下文时返回 -1。 */
    @JvmStatic
    fun currentRecomposeCount(): Int = ReactiveContext.currentEffectRunCount()

    /** 当前追踪帧依赖数量；不在追踪上下文时返回 -1。 */
    @JvmStatic
    fun currentDepsCount(): Int = ReactiveContext.currentTrackedDeps()?.size ?: -1

    /** 是否处于追踪上下文（Effect / Computed 求值中）。 */
    @JvmStatic
    fun inTrackingContext(): Boolean = ReactiveContext.currentTrackedDeps() != null

    /**
     * 判断给定对象（[Signal] / [Computed] 实例）是否被当前追踪帧依赖。
     *
     * 按身份比较。`Trackable` 接口为包私有，对外以 [Any] 形参 + 身份判定提供，让 debug 内建能用
     * `EvalContext` 持有的 Signal/Computed 实例反查依赖名。
     */
    @JvmStatic
    fun isTracked(candidate: Any?): Boolean {
        if (candidate == null) {
            return false
        }
        val deps = ReactiveContext.currentTrackedDeps() ?: return false
        return deps.any { it === candidate }
    }
}
